/** Sweatpants Component */
import{compose as r,border as p,color as a,flexbox as i,grid as s,layout as t,position as e,shadow as m,space as d,typography as l}from"styled-system";import x from"styled-components";const y=r(p,a,i,s,t,e,m,d,l),o=x.div`
  ${y}
`;o.displayName="Box";export{o as Box};
//# sourceMappingURL=index.esm.js.map
